import * as React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { doFilter, setOrdem, triggerLoadData, triggerToggleHiddenPrint, triggerTrocaFiltro } from "./ClientesSlice";
import { Box, Button, Grid, Input, Link, Option, Select, Stack, Table, Typography } from '@mui/joy';
import { v4 } from "uuid";
// import { UNSAFE_useScrollRestoration } from 'react-router-dom';
import { formatDateJavaComHoras } from '../core/helpers';

function ClientesDashboard() {

    var dispatch = useDispatch()
    var loading = useSelector((state) => state.clientes.loading)
    var ultimaAlteracao = useSelector((state) => state.clientes.ultimaAlteracao)
    var dataFiltered = useSelector((state) => state.clientes.dataFiltered)
    var faturamento = useSelector((state) => state.clientes.faturamento)
    var filtros = useSelector((state) => state.clientes.filtros)
    var ordem = useSelector((state) => state.clientes.ordem)
    var hidePrint = useSelector((state) => state.clientes.hidePrint)

    var carregaData = () => {
        dispatch(triggerLoadData())
    }

    React.useEffect(() => {
        carregaData();
    }, []);

    if (loading) {
        return <>
            <Grid xs={12}>
                Loading...
            </Grid></>
    }

    var changeCurva = (a, e) => {
        dispatch(triggerTrocaFiltro({
            campo: "curva",
            valor: e
        }))
    }
    var changeRecencia = (a, e) => {
        dispatch(triggerTrocaFiltro({
            campo: "recencia",
            valor: e
        }))
    }
    var changeFrequencia = (a, e) => {
        dispatch(triggerTrocaFiltro({
            campo: "frequencia",
            valor: e
        }))
    }
    var changeNovo = (a, e) => {
        dispatch(triggerTrocaFiltro({
            campo: "novo",
            valor: e
        }))
    }
    var changeCliente = (a, b) => {
        dispatch(triggerTrocaFiltro({
            campo: "cliente",
            valor: a.target.value
        }))
    }
    var changePF = (a, e) => {
        dispatch(triggerTrocaFiltro({
            campo: "pf",
            valor: e
        }))
    }

    var defineOrdem = (ordem) => {
        dispatch(setOrdem(ordem))
        dispatch(doFilter())
    }

    var toggleHiddenPrint = () => {
        dispatch(triggerToggleHiddenPrint())
    }
    return <>
        <Grid sx={{ padding: "10px" }}>
            <Stack direction={"column"} spacing={1}>
                <Button color='primary' onClick={toggleHiddenPrint}>
                    {!hidePrint && "Esconder para Impressão"}
                    {hidePrint && "Mostrar filtros e dados"}
                </Button>
                <Typography>
                    Ultima atualização: {(ultimaAlteracao)}
                </Typography>
            </Stack>
        </Grid>
        { !hidePrint && <Grid sx={{ padding: "10px" }}>
            {faturamento != null && <Table size="small" aria-label="striped table" stripe={"odd"}>
                <thead>
                    <tr>
                        <th style={{ width: "15%", textAlign: "left" }}>Curva</th>
                        <th style={{ width: "12%", textAlign: "left" }}>Faturamento</th>
                        <th style={{ width: "12%", textAlign: "left" }}>Clientes</th>
                        <th style={{ textAlign: "left" }}>Faturamento médio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr key={v4()}>
                        <td>TODOS</td>
                        <td>R$ {faturamento.medioMensal.toFixed(2)}</td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                    <tr key={v4()}>
                        <td>TODOS s/ consumidor final</td>
                        <td>R$ {faturamento.medioMensalSemConsumidor.toFixed(2)}</td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                    {Object.keys(faturamento.curva).map(e => {
                        return <tr key={v4()}>
                            <td>{e.toUpperCase()}</td>
                            <td>R$ {faturamento.curva[e].total.toFixed(2)}</td>
                            <td>{faturamento.curva[e].clientes}</td>
                            <td>R$ {(faturamento.curva[e].total / faturamento.curva[e].clientes).toFixed(2)}</td>
                        </tr>
                    })}
                </tbody>
            </Table>}
        </Grid> }
        { !hidePrint && <Grid sx={{ padding: "10px" }}>
            {faturamento != null && <Table size="small" aria-label="striped table" stripe={"odd"}>
                <thead>
                    <tr>
                        <th style={{ width: "12%", textAlign: "left" }}>Cliente</th>
                        <th style={{ width: "15%", textAlign: "left" }}>Faturamento</th>
                        <th style={{ width: "12%", textAlign: "left" }}>Total</th>
                        <th style={{ textAlign: "left" }}>Média por cliente</th>
                    </tr>
                </thead>
                <tbody>
                    <tr key={v4()}>
                        <td>PF</td>
                        <td>R$ {faturamento.pf.total.toFixed(2)} ({Math.ceil((faturamento.pf.total / (faturamento.medioMensalSemConsumidor)) * 100)} %)</td>
                        <td>{faturamento.pf.clientes}</td>
                        <td>R$ {faturamento.pf.media.toFixed(2)}</td>
                    </tr>
                    <tr key={v4()}>
                        <td>PJ</td>
                        <td>R$ {faturamento.pj.total.toFixed(2)} ({Math.ceil((faturamento.pj.total / (faturamento.medioMensalSemConsumidor)) * 100)} %)</td>
                        <td>{faturamento.pj.clientes}</td>
                        <td>R$ {faturamento.pj.media.toFixed(2)}</td>
                    </tr>
                </tbody>
            </Table>}
        </Grid> }
        { !hidePrint && <Grid sx={{ padding: "10px" }}>
            <Stack direction={"row"} spacing={2}>
                <Box>
                    <Stack>
                        Curva
                        <Select value={filtros.curva} onChange={changeCurva}>
                            <Option value={"TODAS"}>Todas</Option>
                            <Option value={"A"}>A</Option>
                            <Option value={"B"}>B</Option>
                            <Option value={"C"}>C</Option>
                            <Option value={"D"}>D</Option>
                        </Select>
                    </Stack>
                </Box>
                <Box>
                    <Stack>
                        Recência
                        <Select value={filtros.recencia} onChange={changeRecencia}>
                            <Option value={"TODAS"}>Todas</Option>
                            <Option value={"OK"}>OK (80%) </Option>
                            <Option value={"ACELERAR"}>Acelerar (90%) </Option>
                            <Option value={"MANTER"}>Manter (110%) </Option>
                            <Option value={"DIMINUINDO"}>Diminuindo (130%)</Option>
                            <Option value={"RECUPERAR"}>Recuperar (160%) </Option>
                            <Option value={"PERDENDO"}>Perdendo (250%)</Option>
                            <Option value={"PERDIDO"}>Perdido (250%+)</Option>
                        </Select>
                    </Stack>
                </Box>
                <Box>
                    <Stack>
                        Frequência
                        <Select value={filtros.frequencia} onChange={changeFrequencia}>
                            <Option value={"TODAS"}>Todas</Option>
                            <Option value={"QUINZENAL"}>Quinzenal</Option>
                            <Option value={"MENSAL"}>Mensal</Option>
                            <Option value={"BIMESTRAL"}>Bimenstral</Option>
                            <Option value={"TRIMESTRAL"}>Trimestral</Option>
                            <Option value={"SEM FREQ."}>Sem freq</Option>
                        </Select>
                    </Stack>
                </Box>
                <Box>
                    <Stack>
                        Novo
                        <Select value={filtros.novo} onChange={changeNovo}>
                            <Option value={"TODAS"}>Todas</Option>
                            <Option value={"NOVOS"}>Novos</Option>
                        </Select>
                    </Stack>
                </Box>
                <Box>
                    <Stack>
                        PF
                        <Select value={filtros.pf} onChange={changePF}>
                            <Option value={"TODAS"}>Todas</Option>
                            <Option value={"PF"}>PF</Option>
                            <Option value={"PJ"}>PJ</Option>
                        </Select>
                    </Stack>
                </Box>
                <Box>
                    <Stack>
                        Produto
                        <Input sx={{ minWidth: "400px" }} value={filtros.cliente} placeholder='Nome...' onChange={changeCliente}></Input>
                    </Stack>
                </Box>
            </Stack>
        </Grid>}
        {!hidePrint && <Grid xs={12} sx={{ padding: " 0 10px" }}>
            <Stack direction={"column"} spacing={2}>
                <Typography>
                    Items : <b>{dataFiltered.length}</b>
                </Typography>
                <Typography>
                    Ordenando por: <b>{ordem}</b>
                </Typography>
                {/* <Typography>
                    Lucro Mensal : <b>R$ {lucroDaBusca.toFixed(2)}</b>
                </Typography>
                <Typography>
                    Giro custo : <b>R$ {giroDaBusca.toFixed(2)} ({Math.ceil((custoDaBusca / (giroDaBusca / 30))).toFixed(0)} dias)</b>
                </Typography>
                <Typography>
                    Custo : <b>R$ {custoDaBusca.toFixed(2)}</b>
                </Typography> */}
            </Stack>
        </Grid> }
        <Grid sx={{ padding: "10px" }}>
            <Table size="small" aria-label="table" >
                <thead>
                    <tr>
                        <th style={{ width: "2%", textAlign: "left" }}>Index</th>
                        <th style={{ width: "2%", textAlign: "left" }}>Cód.</th>
                        <th style={{ width: "2%", textAlign: "left" }}>Curva</th>
                        <th style={{ width: "5%", textAlign: "left" }}><Link onClick={() => defineOrdem("Fatur. Mensal")}>Fatur. Mensal</Link></th>
                        <th style={{ width: "2%", textAlign: "left" }}>PF</th>
                        <th style={{ width: "22%", textAlign: "left" }}>
                            <Link onClick={() => defineOrdem("Nome")}>Nome</Link>
                        </th>
                        <th style={{ width: "12%", textAlign: "left" }}>Recência</th>
                        <th style={{ width: "5%", textAlign: "left" }}>Frequência</th>
                        <th style={{ width: "5%", textAlign: "left" }}>Novo (dias)</th>
                        {/* <th style={{ width: "7%", textAlign: "left" }}>Est. Atual</th>
                        <th style={{ width: "7%", textAlign: "left" }}>Est. Sug</th>
                        <th style={{ width: "7%", textAlign: "left" }}>Est. Custo</th>
                        <th style={{ textAlign: "left" }}>Situação</th> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        /* style={tableRowStyle(e)} */
                        dataFiltered
                            .map(e => {
                                var diff = e.diasUltimaVenda - e.diasParaUmaVenda
                                return <tr key={v4()} >
                                    <td>{e.index}</td>
                                    <td>{e.cod}</td>
                                    <td>{e.curva}</td>
                                    <td>{e.retornoMensal}</td>
                                    <td>{e.pf ? "PF" : "PJ"}</td>
                                    <td>{e.nome}</td>
                                    <td style={{ backgroundColor: e.recenciaColor, paddingLeft: "5px", color: e.recenciaTextColor }}>{e.recencia} {
                                        diff > 0 ? " - " + diff + " dias em atraso" : ""
                                    }</td>
                                    <td style={{ backgroundColor: e.freqColor, paddingLeft: "5px", color: e.freqTextColor }}>{e.frequencia} {(e.vendasPorMes).toFixed(1)}</td>
                                    <td style={{ backgroundColor: e.novoColor, color: "#000", paddingLeft: "5px" }}>{e.novo ? e.novo + " (" + e.diasDataCadastro + ")" : ""} </td>
                                </tr>
                            })
                    }
                    {/* {data
                        .filter(e => {
                            if (filtros.curva == "TODAS") return true
                            else return e.curva == filtros.curva
                        })
                        .filter(e => {
                            if (filtros.situacao == "TODAS") return true
                            else {
                                if (e.status == null)
                                    return false
                                return e.status.flag.includes(filtros.situacao)
                            }
                        })
                        .filter(e => {
                            if (filtros.produto.trim().length == 0) return true
                            else return e.nome.toUpperCase().includes(filtros.produto.toUpperCase())
                        })
                        // .forEach( e => {

                        //     dispatch(updateSomatorios({
                        //         custo : custoDaBusca + e.estoqueCusto,
                        //         lucro : lucroDaBusca + e.retornoMensal
                        //     }))

                        // })
                        .map(e => {

                            return <tr key={v4()} style={tableRowStyle(e)}>
                                <td>{e.index}</td>
                                <td>{e.curva}</td>
                                <td>{e.retornoMensal}</td>
                                <td>{e.estoqueQtde}</td>
                                <td>{e.estoqueSugerido}</td>
                                <td>{e.estoqueCusto}</td>
                                <td>{e.nome}</td>
                                <td>{e.status != null ? e.status.text : ""}</td>
                            </tr>
                        })} */}
                </tbody>
            </Table>

        </Grid>
    </>
}

export default ClientesDashboard